import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

export interface FundLeiFormFieldProps {}

export const FundLeiFormField: React.FC<FundLeiFormFieldProps> = ({}) => {
  const { control, register } = useFormContext<{ fund_lei: number }>()

  return (
    <FormField
      name="fund_lei"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center  gap-2">
              <FormLabel>Fund LEI</FormLabel>
              <FormError />
            </div>
            <Input {...register('fund_lei')} placeholder={'Enter a fund lei...'} />
          </FormItem>
        )
      }}
    />
  )
}
